import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import Close from 'components/bolt/icons/close';
import CalendarRemindButtons from 'components/bolt/calendarRemind/calendarRemindButtons';
import * as webp from 'utils/bolt/webp';
import formatDateTime from 'utils/formatDateTime';
import s from 'components/bolt/homeEnt/homeEnt.sss';

export default class MerchantPanel extends Component {
	renderProducts(availability, data, selectedRegionData = {}) {
		if (availability === 'comingSoon') return;
		const { appData, onPriceBtnClick = () => {} } = this.props;
		const copy = appData?.copy || {};
		const homeEntData = appData?.pages?.[this.props.pageId || 'boltHomeEnt']?.data || {};
		const fontStyling = appData?.styling.fontVariables || {};

		const availabilityNames = {
			buy: selectedRegionData.buy || copy.baseCopy.$AVAIL_BUY || 'Buy',
			rent: selectedRegionData.rent || copy.baseCopy.$AVAIL_RENT || 'Rent',
			preOrder: selectedRegionData.preOrder || copy.baseCopy.$AVAIL_PREORDER ||'Pre-order',
			stream: selectedRegionData.stream || copy.baseCopy.$AVAIL_STREAM || 'Stream'
		};

		const currency = selectedRegionData.currency || homeEntData.currency;
		const currencyPosition = selectedRegionData.currencyPosition || homeEntData.currencyPosition;
		const currencyPrepend = currencyPosition === 'before' ? currency : '';
		const currencyAppend = currencyPosition === 'after' ? currency : '';
		return (
			<div class={s.availability} key={availability}>
				<div class={joinClasses(s.availName, fontStyling.homeEntAvailName)}>
					<span>{availabilityNames[availability] || copy.baseCopy[`$AVAIL_${availability.toUpperCase()}`] || availability}</span>
				</div>
				<div class={s.products}>
					{Array.isArray(data) && data.map((p, i) => {
						const price = typeof p.price === 'string' ? parseFloat(p.price) : p.price;
						return (
							<div class={s.product} key={i}>
								<span class={joinClasses(s.edition, fontStyling.homeEntEdition)}>{p.edition}</span>
								<a class={s.link} href={p.link} target="_blank" onClick={() => onPriceBtnClick(p, availability)}>
									<span class={fontStyling.homeEntPriceBtn}>
										{price ? `${currencyPrepend}${price.toFixed(2)}${currencyAppend}` : selectedRegionData.priceBtnText || copy.baseCopy.$VISIT_SITE}
									</span>
								</a>
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	render(props) {
		const {
			appData,
			merchantScreenOpen,
			userSelectedAvailabilities,
			availabilityOrder,
			maybeCloseMerchantSection = () => {},
			closeMerchantSection = () => {},
			selectedLogo,
			selectedMerchantData,
			selectedMerchant,
			fallbackFormat,
			selectedRegionData,
			logoAltText,
			isPreviewPanel
		} = props;

		const availabilities = Object.keys(selectedMerchantData)
			.filter(a => a !== 'textOverlay' && userSelectedAvailabilities.includes(a) && Object.keys(selectedMerchantData[a]).length)
			.sort((a, b) => availabilityOrder.indexOf(b) - availabilityOrder.indexOf(a));

		const hasComingSoon = availabilities && availabilities.includes('comingSoon') && !selectedMerchantData.comingSoon.expired;
		const pageData = appData?.pages?.[this.props.pageId || 'boltHomeEnt']?.data || {};
		const merchantDetailsOverrides = pageData.overrideMerchantDetails || {};
		const logoShade = appData?.styling.logoShade || 'light';
		const copy = appData.copy?.baseCopy;

		let calRemindData;
		let remindMeDate;
		let calRemindTitle;
		let calRemindBody;
		let chooseCalCopy;
		let availOnDateCopy;
		if (hasComingSoon) {
			const comingSoonData = selectedMerchantData.comingSoon || {};
			const merchantName = comingSoonData.merchantName ||
			merchantDetailsOverrides[selectedMerchant]?.name ||
			selectedMerchantData.merchantName || '';
			calRemindData = pageData.calRemind || {};

			const remindMeDateWithOffset = new Date(comingSoonData.date);
			remindMeDate = new Date(remindMeDateWithOffset.getTime() + remindMeDateWithOffset.getTimezoneOffset() * 60000);
			const formattedDate = formatDateTime(remindMeDate, 'MMM dd', copy.$DATETIME_LOCALE);
			calRemindTitle = comingSoonData?.calendarCustomisation?.calRemindTitle || selectedRegionData.calRemindTitle || copy[calRemindData.title] || calRemindData.title || '';
			const siteUrl = appData?.meta.url || '';
			calRemindBody = (comingSoonData?.calendarCustomisation?.calRemindBody || selectedRegionData.calRemindBody || copy[calRemindData.body] || calRemindData.body || '').replace('<merchant>', merchantName).replace('%VANITY_DOMAIN%', siteUrl);
			chooseCalCopy = selectedRegionData.calRemindCta || copy[calRemindData.cta] || calRemindData.cta || '';
			availOnDateCopy = (selectedRegionData.calRemindAvailOnDate || copy[calRemindData.available] || copy.$AVAILABLE_ON_DATE_COPY || '').replace('<date>', formattedDate);
		}

		return (
			<div
				class={joinClasses({
					s,
					container: true,
					hidden: !availabilities.length || !merchantScreenOpen,
					merchantSectionContainer: true,
					isPreviewPanel: isPreviewPanel
				})}
				ref={e => this.$merchantSectionContainer = e}
				onClick={maybeCloseMerchantSection}
			>
				<div class={s.scroller} ref={e => this.$merchantSectionScroller = e} onClick={maybeCloseMerchantSection}>
					<div class={joinClasses(s.content, hasComingSoon && s.comingSoonContent)}>
						<svg class={s.cutout} viewBox="0 0 10 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M10,0 L10,100 L0,100 L0.000674999097,61.3169386 C4.66109189,59.6694024 8,55.2246231 8,50 C8,44.7753769 4.66109189,40.3305976 0.000674999097,38.6830614 L0,0 L10,0 Z"
								fill-rule="evenodd"
							/>
						</svg>
						<div class={joinClasses(s.sticky, hasComingSoon && s.stickyComingSoon)}>
							<webp.Picture class={s.logo} src={selectedLogo} alt={logoAltText} fallbackFormat={fallbackFormat} />
							<Close class={s.close} onClick={closeMerchantSection} />
						</div>
						{hasComingSoon && <span class={s.availOnDateCopy}>{availOnDateCopy}</span>}
						{!hasComingSoon && availabilities.map(availability => this.renderProducts(availability, selectedMerchantData[availability], selectedRegionData))}
						{hasComingSoon && (
							<div class={s.calRemindSection}>
								<CalendarRemindButtons
									remindMeDate={remindMeDate}
									summary={calRemindTitle}
									description={calRemindBody}
									calObj={calRemindData}
									isHomeEnt
									chooseCalCopy={chooseCalCopy}
									iconShade={logoShade}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}